// Include a phone held sideways without changing a laptop at the same width.
export const phoneLayoutQuery = '(max-width: 800px), (max-width: 950px) and (max-height: 500px) and (pointer: coarse)';
